import isFunction from "lodash-es/isFunction";

import { EntityType } from "@mapmycustomers/shared";
import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";
import MarkerSize from "@mapmycustomers/shared/enum/MarkerSize";
import { ActivityPin } from "@mapmycustomers/shared/types/map";

import MarkerEffect from "@app/enum/MarkerEffect";
import colors from "@app/styles/_colors.module.scss";
import getContrastColor from "@app/util/colors/getContrastColor";
import { PIN_ZINDEX } from "@app/util/map/consts";
import svgToDataUrl from "@app/util/map/svgToDataUrl";

import getResultingSvg from "./getResultingSvg";
import { getScaledSizeByMarker } from "./getScaledSize";
import getSvgEffect from "./getSvgEffect";
import getSvgForIcon from "./getSvgForIcon";
import getSvgForShape from "./getSvgForShape";

interface StyleArguments {
  effect?: ((activityPin: ActivityPin) => MarkerEffect) | MarkerEffect;
  markerSize: MarkerSize;
  zIndex?: number;
}

const defaultActivityStyleGetter = ({
  effect = MarkerEffect.SHADOW,
  markerSize,
  zIndex = PIN_ZINDEX,
}: StyleArguments): ((item: ActivityPin) => google.maps.Data.StyleOptions) => {
  return (entityPin: ActivityPin) => {
    const markerEffect = isFunction(effect) ? effect(entityPin) : effect;

    const entityType = entityPin.data.account
      ? EntityType.COMPANY
      : entityPin.data.contact
      ? EntityType.PERSON
      : entityPin.data.deal
      ? EntityType.DEAL
      : undefined;

    const entityColor = entityPin.data.account
      ? colors.primary100
      : entityPin.data.contact
      ? colors.green100
      : entityPin.data.deal
      ? colors.red100
      : colors.slate;

    const iconSvg = getSvgForIcon(
      MarkerShape.SQUARE,
      entityType,
      getContrastColor(entityColor) === "black" ? colors.slate : colors.white
    );

    const { badgeAnchor, badgeShapeIncreaser, shapeAnchor, shapeSize, shapeSvg } = getSvgForShape(
      MarkerShape.SQUARE,
      entityColor,
      colors.accentGray
    );
    const shapeEffect = getSvgEffect(markerEffect, shapeSize);

    const { anchor, size, svg } = getResultingSvg(
      shapeSvg,
      shapeSize,
      shapeAnchor,
      shapeEffect,
      iconSvg,
      "",
      badgeAnchor,
      badgeShapeIncreaser
    );

    return {
      icon: {
        anchor: new google.maps.Point(...getScaledSizeByMarker(anchor, markerSize)),
        scaledSize: new google.maps.Size(...getScaledSizeByMarker(size, markerSize)),
        url: svgToDataUrl(svg),
      },
      zIndex,
    };
  };
};

export default defaultActivityStyleGetter;
